<app-pdftron
	#pdfViewer
	class="min-h-0"
	[fileName]="formName()"
	[formData]="formData()"
	[googleSrcUrl]="googleSrcUrl()"
	(onFieldChanged)="fieldChanged($event)"
	[disabledElements]="['menuButton']"
	[overrideFieldFonts]="false"
	[explicitySetFieldDefaults]="false"
/>
